<script>
export let team_instance;


export let tracksuits_form_deadline;


const number_of_tracksuits_available = team_instance.number_of_tracksuits_available;


// alert(number_of_tracksuits_available);
// console.log(number_of_tracksuits_available);



const pants_sizes = [
	{
		size_value: 'S',
		size_name: 'S',
		number: 'i',
	},
	{
		size_value: 'M',
		size_name: 'M',
		number: 'i',
	},
	{
		size_value: 'L',
		size_name: 'L',
		number: 'i',
	},
	{
		size_value: 'XL',
		size_name: 'XL',
		number: 'i',
	},
	{
		size_value: 'XXL',
		size_name: 'XXL',
		number: 'i',
	},
	{
		size_value: 'XXXL',
		size_name: 'XXXL',
		number: 'i',
	},
];

const jacket_sizes = [
	{
		size_value: 'S',
		size_name: 'S',
		number: 'i',
	},
	{
		size_value: 'M',
		size_name: 'M',
		number: 'i',
	},
	{
		size_value: 'L',
		size_name: 'L',
		number: 'i',
	},
	{
		size_value: 'XL',
		size_name: 'XL',
		number: 'i',
	},
	{
		size_value: 'XXL',
		size_name: 'XXL',
		number: 'i',
	},
	{
		size_value: 'XXXL',
		size_name: 'XXXL',
		number: 'i',
	},
];



import TracksuitThumb from 'components/views/my/team/thumbs/Tracksuit.svelte';


</script>



<style>

#tracksuits-table {
	margin-bottom: 35vh;
}

</style>



<div class="panel" id="tracksuits-table">

	<div class="panel-heading">

		<div class="columns is-2 is-variable is-mobile">

			<div class="column is-2">
				<span></span>
			</div>

			<div class="column is-2">
				<span>Jacket Size</span>
			</div>

			<div class="column is-2">
				<span>Pants Size</span>
			</div>

			<div class="column is-2">
				<span>Coach Name</span>
			</div>

			<div class="column is-3">
				<span></span>
			</div>

		</div>

	</div>


	{#each Array(number_of_tracksuits_available) as _, i}
		<TracksuitThumb {team_instance} index={i+1} {pants_sizes} {jacket_sizes} on:tracksuit_saved_msg {tracksuits_form_deadline} />
	{/each}


	<!-- each as  -->

	<!-- /each -->

</div>


